import React, { useState } from 'react';
import {
    Home,
    Mail,
    Phone,
    MapPin,
    Facebook,
    Twitter,
    Instagram,
    Linkedin,
    Youtube,
    ArrowRight,
    Building,
    Users,
    Shield,
    Award
} from 'lucide-react';
import {useLocation, useNavigate} from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const currentYear = new Date().getFullYear();

    const hiddenPaths = [
        '/login',
        '/register',
        '/forgot-password',
        '/reset-password',
        '/verify-email',
        '/onboarding',
        '/setup',
        '/welcome'
    ];


    // Mock current path - in real app, use useLocation hook
    const location = useLocation();
    const currentPath = location.pathname;

    // Check if header should be hidden on current path
    const shouldHideHeader = hiddenPaths.includes(currentPath);

    const handleNavigation = (path) => {
        console.log('Navigate to:', path);
        // Replace with actual navigation logic
        navigate(path);
    };


    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            console.log('Subscribe email:', email);
            // Add newsletter subscription logic here
            setEmail('');
            alert('Thank you for subscribing!');
        }
    };

    const quickLinks = [
        { name: 'Find Homes', href: '/listings' },
        // { name: 'Map Search', href: '/map' },
        // { name: 'Neighborhoods', href: '/neighborhoods' },
        { name: 'Rental Guide', href: '/rental-guide' },
        // { name: 'Property Calculator', href: '/calculator' },
        { name: 'Moving Services', href: '/moving-services' }
    ];

    const forRenters = [
        { name: 'Rental Guide', href: '/rental-guide' },
        { name: 'How to Rent', href: '/how-to-rent' },
        { name: 'Renter Rights', href: '/renter-rights' },
        { name: 'Application Tips', href: '/application-tips' },
        { name: 'Moving Checklist', href: '/moving-checklist' },
        { name: 'Tenant Resources', href: '/tenant-resources' },
        { name: 'Lease Templates', href: '/lease-templates' }
    ];

    const forOwners = [
        { name: 'List Your Property', href: '/list-property' },
        { name: 'Property Management', href: '/property-management' },
        // { name: 'Tenant Screening', href: '/tenant-screening' },
        // { name: 'Market Analysis', href: '/market-analysis' },
        { name: 'Owner Dashboard', href: '/manager' },
        // { name: 'Maintenance Services', href: '/maintenance' }
    ];

    const company = [
        { name: 'About Us', href: '/about' },
        // { name: 'Our Team', href: '/team' },
        // { name: 'Careers', href: '/careers' },
        // { name: 'Press', href: '/press' },
        // { name: 'Blog', href: '/blog' },
        { name: 'Contact Us', href: '/contact' }
    ];

    const legal = [
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Terms of Service', href: '/terms-of-service' },
        // { name: 'Cookie Policy', href: '/cookie-policy' },
        // { name: 'Fair Housing', href: '/fair-housing' },
        // { name: 'Accessibility', href: '/accessibility' },
        // { name: 'Site Map', href: '/sitemap' }
    ];

    const socialLinks = [
        { name: 'Facebook', icon: Facebook, href: 'https://facebook.com' },
        { name: 'Twitter', icon: Twitter, href: 'https://twitter.com' },
        { name: 'Instagram', icon: Instagram, href: 'https://instagram.com' },
        { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com' },
        { name: 'YouTube', icon: Youtube, href: 'https://youtube.com' }
    ];

    const stats = [
        { label: 'Active Listings', value: '10,000+', icon: Building },
        { label: 'Happy Tenants', value: '50,000+', icon: Users },
        { label: 'Verified Properties', value: '100%', icon: Shield },
        { label: 'Years Experience', value: '15+', icon: Award }
    ];

    // Don't render header if on hidden paths
    if (shouldHideHeader) {
        return null;
    }


    return (
        <footer className="bg-soil-900 text-karibu-100">
            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
                    {/* Company Info */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center space-x-2 mb-6">
                            <div className="w-10 h-10 bg-highland-500 rounded-lg flex items-center justify-center">
                                <Home className="w-6 h-6 text-karibu-100" />
                            </div>
                            <span className="text-2xl font-display font-bold">Rent Utopia</span>
                        </div>
                        <p className="text-soil-100/70 mb-6 text-sm leading-relaxed">
                            Your trusted partner in finding the perfect rental home. We connect tenants with quality properties and help property owners manage their investments efficiently.
                        </p>

                        {/* Contact Info */}
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3 text-sm text-soil-100/70">
                                <MapPin className="w-4 h-4 text-dawn-500" />
                                <span>123 Business Street, Nairobi, Kenya</span>
                            </div>
                            <div className="flex items-center space-x-3 text-sm text-soil-100/70">
                                <Phone className="w-4 h-4 text-dawn-500" />
                                <span>+254 712 292 899</span>
                            </div>
                            <div className="flex items-center space-x-3 text-sm text-soil-100/70">
                                <Mail className="w-4 h-4 text-dawn-500" />
                                <span>itorama254@gmail.com</span>
                            </div>
                        </div>

                        {/* Social Links */}
                        <div className="flex space-x-4 mt-6">
                            {socialLinks.map((social) => {
                                const Icon = social.icon;
                                return (
                                    <button
                                        key={social.name}
                                        onClick={() => window.open(social.href, '_blank')}
                                        className="w-10 h-10 bg-soil-800 rounded-lg flex items-center justify-center hover:bg-highland-500 transition-colors duration-200"
                                        aria-label={`Visit our ${social.name} page`}
                                    >
                                        <Icon className="w-5 h-5" />
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
                        <ul className="space-y-3">
                            {quickLinks.map((link) => (
                                <li key={link.name}>
                                    <button
                                        onClick={() => handleNavigation(link.href)}
                                        className="text-soil-100/70 hover:text-dawn-500 transition-colors duration-200 text-sm text-left"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* For Renters */}
                   {/* <div>
                        <h3 className="text-lg font-semibold mb-6">For Renters</h3>
                        <ul className="space-y-3">
                            {forRenters.map((link) => (
                                <li key={link.name}>
                                    <button
                                        onClick={() => handleNavigation(link.href)}
                                        className="text-soil-100/70 hover:text-dawn-500 transition-colors duration-200 text-sm text-left"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
*/}
                    {/* For Owners */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6">For Owners</h3>
                        <ul className="space-y-3">
                            {forOwners.map((link) => (
                                <li key={link.name}>
                                    <button
                                        onClick={() => handleNavigation(link.href)}
                                        className="text-soil-100/70 hover:text-dawn-500 transition-colors duration-200 text-sm text-left"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6">Company</h3>
                        <ul className="space-y-3">
                            {company.map((link) => (
                                <li key={link.name}>
                                    <button
                                        onClick={() => handleNavigation(link.href)}
                                        className="text-soil-100/70 hover:text-dawn-500 transition-colors duration-200 text-sm text-left"
                                    >
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>

            {/* Bottom Bar */}
            <div className="border-t border-soil-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="text-center md:text-left">
                            <p className="text-soil-100/70 text-sm">
                                © {currentYear} Rent Utopia. All rights reserved.
                            </p>
                        </div>
                        <div className="mt-4 md:mt-0">
                            <div className="flex flex-wrap justify-center md:justify-end space-x-6">
                                {legal.map((link) => (
                                    <button
                                        key={link.name}
                                        onClick={() => handleNavigation(link.href)}
                                        className="text-soil-100/70 hover:text-dawn-500 transition-colors duration-200 text-sm"
                                    >
                                        {link.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Fair Housing Notice */}
                    <div className="mt-6 pt-6 border-t border-soil-800">
                        <p className="text-xs text-soil-100/50 text-center leading-relaxed">
                            Rent Utopia is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards. This website is compliant with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. We support and adhere to the Equal Housing Opportunity Act.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;